export default {
  subheading: {
    color: '#7C7C80',
    fontSize: '18px',
    fontWeight: '500',
    textTransform: 'uppercase',
    margin: '10px 0',
  },
  sectionRow: {
    display: 'flex',
    alignItems: 'center',
    padding: '5px',
  },
  formLabel: {
    width: 60,
    marginRight: 10,
  },
  input: {
    width: 50,
  },
  assigneeSection: {
    height: 130,
  },
};
